import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { UnsubscribeOnDestroy } from 'app/projects/core/src/lib/models/unsubscribe-on-destroy';
import { fuseAnimations } from 'app/projects/fuse/src/lib/animations';
import { BehaviorSubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-name-toggle-dialog',
    templateUrl: './name-toggle.component.html',
    styleUrls: ['./name-toggle.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
})
export class NameToggleDialogComponent extends UnsubscribeOnDestroy {
    @Input()
    dialogTitle: string;

    @Input()
    placeholder: string;

    @Input()
    buttonLabel: string = 'GENERAL.BUTTON.SAVE';

    @Input()
    label?: string;

    @Input()
    toggleLabel: string;

    @Input()
    showSpinner = false;

    @Input()
    disableUntilChanged = false;

    @Input()
    set addEmailValidation(value: boolean) {
        if (value) {
            this.nameCtrl.setValidators([Validators.email]);
        }

        this.nameCtrl.updateValueAndValidity(); // Trigger validation update
    }

    @Input()
    set name(value: string) {
        this.nameCtrl.setValue(value);
    }

    @Input()
    set target(value: number) {
        this.targetCtrl.setValue(value);
    }

    @Input()
    set toggle(value: boolean) {
        this.toggleCtrl.setValue(value);
    }

    nameCtrl = new FormControl('', [Validators.required]);
    targetCtrl = new FormControl(null);
    toggleCtrl = new FormControl(false);

    @Output()
    save = new EventEmitter<{ name: string; toggleCtrl: boolean; targetCount?: number }>();

    errors = new BehaviorSubject<{ message: string }>(null);

    constructor(public dialogRef: MatDialogRef<NameToggleDialogComponent>) {
        super();

        this.errors
            .asObservable()
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((error) => {
                this.nameCtrl.setErrors(error);
            });
    }

    saveDialog(): void {
        this.save.emit({ name: this.nameCtrl.value.trim(), toggleCtrl: this.toggleCtrl.value, targetCount: this.targetCtrl.value });
    }
}
